export const NotFound = () => {
    return (
        <div className='yellow-bg container hurme-3-regular letter-spacing'>
            <h1>404</h1>
            <h2>Oops... something went wrong</h2>
        </div>
    )
}